module.exports = __webpack_public_path__ + "static/assets/d2def3685a9cd9760e2869888f8c7ac0.png";